import { Pipe, PipeTransform } from '@angular/core';
import { RetailerLocation } from 'src/models/RetailerLocation';

@Pipe({
  name: 'locationFormat'
})
export class LocationFormatPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (!value) {
      return null;
    }
    const loc = <RetailerLocation>value;
    let disp = "";
      if (loc.address1) {
        disp = disp + loc.address1;
      }
      if (loc.city) {
        if (disp) disp += " ";
        disp += loc.city;
      }
      if (loc.state) {
        if (loc.city) disp +=", ";
        else if (disp) disp += " ";
        disp += loc.state;
      }
      if (loc.postalCode) {
        if (disp) disp += " ";
        disp += loc.postalCode;
      }
      if (!disp) {
        disp = "(New Location)";
      }
      return disp;
  }

}
